import type { TFunction } from 'i18next'

import locales from '@src/config/locales'

export function getAboutUsLinks(t: TFunction, locale: string) {
  return [
    { title: t('aboutUsTitle'), link: locales[locale].aboutUsPath },
    { title: t('afiUExperience'), link: locales[locale].vivreAfiUPath },
    { title: t('theTeam'), link: locales[locale].teamPath },
    { title: t('ourOffices'), link: locales[locale].ourOfficesPath },
    { title: t('partnersAndCertifications'), link: locales[locale].partnersCertificationsPath },
    { title: t('careers'), link: locales[locale].careersPath },
  ]
}
